import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconNewspaper3"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4V20H22V4H2ZM12 8H18.5V9.5H12V8ZM12 11.25H18.5V12.75H12V11.25ZM5.5 14.5H18.5V16H5.5V14.5ZM5.5 8V12.75H7V10.6093L8.48204 12.75H10V8H8.5V10.1407L7.01796 8H5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNewspaper3;
